export const MA_PRIME_RENOV_INFO = `est une aide publique dont le montant varie en fonction des revenus et du type de travaux.`;
export const PRIME_HELLIO_INFO = `est versée par les fournisseurs d'énergie, obligés de financer des opérations d'économies d'énergie.`;
export const MA_PRIME_ACCOMPAGNATEUR_INFO =
  "est une aide publique donnée par l'Anah sur l'accompagnement Mon Accompagnateur Rénov' (MAR)";
